module.exports = __webpack_public_path__ + "img/2.41e6b53f.png";